import { Station, createCtx } from '@mi-front/core';
import { PropsWithChildren, useEffect } from 'react';
import { TimezoneCtxProvider } from '../context/timezone';
import { useStationsStore } from '../stations/stores';

export const [useStationCtx, _StationCtxProvider] = createCtx<Station>({
  throwIfMissingProvider: true,
});

export const StationCtxProvider = ({
  station,
  children,
}: PropsWithChildren<{ station: Station }>) => {
  const addRecentStation = useStationsStore((state) => state.addRecentStation);

  useEffect(() => {
    // Add to recent stations in Zustand store
    addRecentStation(station.id);
  }, [station, addRecentStation]);

  return (
    <_StationCtxProvider value={station}>
      {station.timezone ? (
        <TimezoneCtxProvider
          value={{
            timezone: station.timezone,
          }}
        >
          {children}
        </TimezoneCtxProvider>
      ) : (
        children
      )}
    </_StationCtxProvider>
  );
};
